export enum RequestType {
  // Curriculum Requests Types
  newCourse = 'newCourse',
  editCourse = 'editCourse',
  deleteCourse = 'deleteCourse',
  newProgram = 'newProgram',
  editProgram = 'editProgram',
  deleteProgram = 'deleteProgram',

  // Event Request Types
  newEvent = 'newEvent',
  editEvent = 'editEvent',

  // Catalog Request Types
  newCatalogPage = 'newCatalogPage',
  editCatalogPage = 'editCatalogPage',
  deleteCatalogPage = 'deleteCatalogPage',

  // Scheduling Request Types
  // This will be `request.type`
  ruleException = 'ruleException',
  sectionChange = 'sectionChange',
  scheduleValidation = 'scheduleValidation',
}

export enum RequestStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  SUSPENDED = 'suspended',
}

export enum RequestChangeType {
  ADD_SECTION = 'addSection',
  EDIT_SECTION = 'editSection',
  DELETE_SECTION = 'deleteSection',
  ADD_SECTION_FROM_COURSE_INVENTORY = 'addSectionFromCourseInventory',
}

export type Request = {
  id: string,
  authorId: string,
  authorType: string,
  request: {
    formattedResponseObject: object,
    objectId?: string,
    changeType?: RequestChangeType,
    addSetupAndTeardownMeetings?: boolean,
  },
  status: RequestStatus,
  isRejected: boolean,
  isApproved: boolean,
  type: RequestType,
  firstEdited: number,
  lastEdited: number,
}
